import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import styled from "@emotion/styled";
export const ButtonWithFooter = ({ footer, children, ...props }) => {
    return (_jsxs(BottomArea, { children: [_jsx(BigButton, { ...props, children: children }), _jsx(FooterText, { children: footer })] }));
};
export const BottomArea = styled.div `
  position: absolute;
  left: 28px;
  right: 28px;
  bottom: 28px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
`;
export const FooterText = styled.div `
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #696969;
  & > a {
    color: #696969;
    font-weight: bold;
  }
`;
export const BigButton = styled.button `
  border: none;
  outline: none;

  border-radius: 16px;
  height: 55px;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;

  background: #000000;
  color: #fff;
  &:hover {
    background: #212121;
  }
  &:active {
    background: #363636;
  }
  transition: 0.2s ease;
  cursor: pointer;
  &:disabled {
    background: #aaa;
    cursor: not-allowed;
  }
`;
//# sourceMappingURL=ButtonWithFooter.js.map